import React, { useEffect } from "react";
import { ReferenceInput, AutocompleteInput, required } from "react-admin";
import _ from "lodash";

const SchoolReferenceInput = ({ type, formData }) => {
  const optionRenderer = (option) => {
    if (!option) return "";
    return `${_.get(option, "team.school.name", "")} (${_.get(
      option,
      "team.name",
      ""
    )})`;
  };

  useEffect(() => {
    /*
      This is not the most ideal way to do what we want to do, 
      however it is the brute force way to do it. 
      Due to how out of date our React-admin package is the tab select
      functionality of the autocomplete is not supported. Support should come in 
      version 4.4.x of react-admin. Until this this brute force method will have to do.
      For a more in depth explanation checkout this comment on github:
      https://github.com/dallasnews/dmn-sportsgraf-admin-web/pull/153#discussion_r1951607236

    */
    const handleGlobalKeyDown = (event) => {
      if (event.key === "Tab") {
        const listbox = document.querySelector('[role="listbox"]');
        if (listbox) {
          const firstOption = listbox.querySelector('[role="option"]');
          if (firstOption) {
            event.preventDefault(); // Stop default tabbing behavior (only when this component is mounted)
            firstOption.click(); // Simulate a click on the top suggestion assuming thats what googan wants.
          }
        }
      }
    };

    document.addEventListener("keydown", handleGlobalKeyDown);
    return () => document.removeEventListener("keydown", handleGlobalKeyDown);
  }, []);

  return (
    <ReferenceInput
      label={`${type} School`}
      source={`${type}SeasonTeam`}
      reference="seasonTeams"
      filter={{
        sportCode: formData.sportCode,
        seasonCode: formData.seasonCode
      }}
      filterToQuery={(searchText) => ({ name: `%${searchText}%` })}
      validate={[required()]}
    >
      <AutocompleteInput
        optionText={optionRenderer}
        optionValue="id"
        options={{
          suggestionsContainerProps: {
            style: { zIndex: 99999 }
          }
        }}
      />
    </ReferenceInput>
  );
};

export default SchoolReferenceInput;
